import Cookies from 'js-cookie'
import { EUtmParameters, type TUtmParameters } from '@/utils/utm/types'

const getUtmParameter = (key: string) => Cookies.get(key)

export const getUtmParametersFromCookies = (): TUtmParameters => {
  const utmCampaign = getUtmParameter(EUtmParameters.UTM_CAMPAIGN)
  const utmMedium = getUtmParameter(EUtmParameters.UTM_MEDIUM)
  const utmSource = getUtmParameter(EUtmParameters.UTM_SOURCE)
  const utmContent = getUtmParameter(EUtmParameters.UTM_CONTENT)
  const utmTerm = getUtmParameter(EUtmParameters.UTM_TERM)

  return {
    utmCampaign,
    utmMedium,
    utmSource,
    utmContent,
    utmTerm,
  }
}
